module.exports={
    zh:{
        garden:"园所名称",
        foodname: '菜品名称',
        Englishname: '英文名称',            
        varietyOfDishes: '菜品种类',
        dishes:'菜品定义',
        search: '搜索',
        reset: '重置',
        newDishes:'新建菜品',
        add: '添加',        
        export: '导出记录',       
        number:'序号',
        operation:"操作",
        check:'查看',
        edit:'编辑',
        delete:"删除",
        allergen:"过敏源",
        ageGroup:'年龄段',
        foodTaboo:'食物禁忌',        
        remark:"备注",
        submit:"提交",
        gardenName:'园所名称',
        date: "日期",
        lastWeek: "上一周",
        nextWeek: "下一周",
        backweek: "返回本周",
        exportRecord: "导出记录",
        replicateWeekRecipe: "复制周食谱",
        textMode: "文字模式",
        pictureMode: "图片模式",
        myFood: "我的菜品",
        save: "保存",
        dateSelection: "日期选择"
    },
    en:{
        garden:"Name of the garden",
        foodname: 'Food name',
        Englishname: 'English name',       
        varietyOfDishes: 'Variety of dishes',  
        dishes:'dishes',
        search: 'search',
        reset: 'reset',
        newDishes:'new dishes',
        add: 'add',
        export: 'export',       
        number:'Number',
        operation:'operation',
        check:'check',
        edit:'edit',
        delete:"delete",
        allergen:'Allergen',
        ageGroup:'age group',
        foodTaboo:'Food Taboo',        
        remark:'remark',
        submit:"submit",
        gardenName:'School',
        date: "date",
        lastWeek: "last week",
        nextWeek: "the next week",
        backweek: "return this week",
        exportRecord: "export record",
        replicateWeekRecipe: "replicate week recipe",
        textMode: "textMode",
        pictureMode: "pictureMode",
        myFood: "my food",
        save: "save",
        dateSelection: "date selection"
    }
}


// WEBPACK FOOTER //
// ./src/components/i18n/lang/recipe.js